<template>
    <div class="shop-desc-box" id="shop-desc">
      <img src="../../assets/images/back-white.png" alt="" v-if="!showtabs && $route.path === '/shop-desc'"
      class="back-img" width="30" height="30" @click="goBack">
      <tabs :tabs="['','产品','详情','']" ref="tabs" style="top: 0;" :style="opacityStyle" v-else-if="showtabs" />
      <van-swipe class="my-swipe" indicator-color="white" lazy-render v-if="$store.state.userAgent === 'Mobile'">
        <van-swipe-item v-for="(imgurl, i) in swipeImgUrl" :key="i">
          <div v-lazy-container="{
               selector: 'img', error: require('../../assets/images/default-shop-desc-swiper.png'),
               loading:require('../../assets/images/default-shop-desc-swiper.png') }">
            <img :data-src="imgurl" alt="" width="100%" height="100%" style="min-height:375px;" @click="handleMainImgClick(imgurl)">
          </div>
        </van-swipe-item>
      </van-swipe>
      <van-swipe class="my-swipe" indicator-color="white" lazy-render autoplay="3000" v-else>
        <van-swipe-item v-for="(imgurl, i) in swipeImgUrl" :key="i">
          <div v-lazy-container="{
               selector: 'img', error: require('../../assets/images/625_625_bg.png'),
               loading:require('../../assets/images/default-shop-desc-swiper.png') }">
            <img :data-src="imgurl" alt="" width="100%" height="100%" style="min-height:375px;">
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="title-box">
        <!-- <div class="price"><span v-show="goods.originalCost">￥</span>{{ goods.minPrice }}</div> -->
        <div class="text">{{ goods.title }}</div>
      </div>
      <div class="shop-card">
        <img :src="logo" alt="" width="50" height="50">
        <div class="text">
          <div class="title">{{ shopName }}</div>
          <div style="display:flex;">
            <div class="span">公司直营</div>
            <!-- <div class="span">品类多样</div> -->
            <div class="span">品质服务</div>
          </div>
        </div>
      </div>
      <div class="description" id="description" ref="description">
          <img v-lazy="url" alt="" v-for="(url, i) in descImgUrl" :key="i" width="100%" @click="handleDescImgClick(url)">
      </div>
      <div class="collapse">
        <van-collapse v-model="activeName" @change="collapseChange">
          <van-collapse-item title="参数规格" name="1">
            <div class="size-desc">
              <div class="row" v-show="goods.sizeDesc && goods.sizeDesc.length === 0">
                <div class="label">产品名称</div><div class="text">{{ goods.title }}</div>
              </div>
              <div class="row" v-for="(item, i) in goods.sizeDesc" :key="i">
                <div class="label">{{ item.labelName }}</div><div class="text">{{ item.value }}</div>
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item title="产品描述" name="2" v-show="goods.desc && goods.desc.length > 0">
            <div class="goods-desc">
              <div v-html="goodsDescHtml"></div>
            </div>
          </van-collapse-item>
          <!-- <van-collapse-item title="价格说明" name="3">
            <div class="price-reminder">
              <div>划线价格：指商品的专柜价、吊牌价、正品零售价、厂家指导价或该商品曾经展示过的销售价等，并非原价，仅供参考。</div>
              <div class="middle-row">未划线价格：指商品的销售价，是您最终决定是否购买商品的依据。</div>
              <div>折扣：页面显示的“折扣”为非划线价格与划线价格的对比，该对比值仅供您参考，不作为计算非划线价格的依据。</div>
            </div>
          </van-collapse-item> -->
          <!-- <van-collapse-item title="消费提醒" name="4">
            <div class="buy-reminder">
              <div>请严格按照使用说明书要求进行使用，清洗时注意断电，避免发生烫伤等意外，产品放置在儿童触摸不到的地方，同时养成用完就断开电源、拔下插头的良好习惯。</div>
            </div>
          </van-collapse-item> -->
        </van-collapse>
      </div>
      <!-- <div ref="recommend">
        <div>推荐</div>
        <div>敬请期待</div>
      </div> -->
      <buy @createOrder="createOrder" :isShortage="isShortage" :showAddCartButton="true" :cartAmount="$store.state.cartAmount" v-show="!showPopup"/>
      <van-popup v-model="showPopup" position="bottom" round :style="'max-height: 80%; max-width:750px;'">
        <div class="title-text">
          <div class="text">款式</div>
          <div class="info">
            <div class="img">
              <img :src="selectSizeImg" alt="" width="75" height="75" @click="handleImgClick" v-show="selectSizeImg">
            </div>
            <div class="price">
              <span class="icon" v-show="orderInfo.originalCost !== '暂无报价'">￥</span>
              <span class="number">{{ orderInfo.originalCost }}</span>
            </div>
          </div>
        </div>
        <div class="order-details">
          <div class="type">
            <div :class="[option.isSelected ? 'option-selected':'option']" v-for="(option) in options" :key="option.id" @click="selectOption(option.id)">
              <div style="display:flex;flex-wrap:nowrap;">
                <div class="label">
                  <div class="img"><img :src="option.sizeImgUrl" alt="" width="30" height="30" v-show="option.sizeImgUrl"></div>
                  <div class="text">{{ option.text }}</div>
                </div>
                <span v-show="option.amount === 0" class="mark">缺货</span>
              </div>
            </div>
          </div>
          <div class="unit" v-show="unitList.length > 0">
            <div class="row">
              <div class="text">数量</div>
              <div class="label-row">
                <div v-for="(unit, index) in unitList" :key="index" :class="[ unit.isSelected ? 'label-active' : 'label']" @click="unitClick(unit.id)">
                  {{ unit.label }}
                </div>
              </div>
            </div>
          </div>
          <div class="amount">
            <div class="title">
              <span>数量</span>
              <van-stepper v-model="orderInfo.amount" @change="changeAmount" input-width="40px" button-size="32px"/>
            </div>
          </div>
        </div>
      </van-popup>
      <div class="button-row" v-show="showPopup">
        <!-- <div class="button-buy-cart" @click="makePhoneCalls" v-if="buttonType === 'addCart'">联系客服</div> -->
        <div class="button-buy-cart" @click="addCart" v-if="buttonType === 'addCart'">放入采购车</div>
        <div class="button-buy" @click="submitOrder" v-else>
          <div class="icon">购买</div>
          <!-- <div class="span">{{ this.orderInfo.originalCost }}</div> -->
        </div>
        <!-- <div class="button-buy" @click="submitOrder" v-else>购买</div> -->
      </div>
      <go-page-confirm v-show="showGoPageConfirm" @handleClick="handleDialogClick"/>
      <!-- 图片预览 -->
      <van-image-preview v-model="showSizeImg" :images="[selectSizeImg]" @change="onChange">
        <template v-slot:index>{{ }}</template>
        <!-- <template v-slot:index>第{{ index + 1 }}页</template> -->
      </van-image-preview>
      <van-image-preview v-model="showDescImg" :images="[selectDescImg]" @change="onDescChange">
        <template v-slot:index>{{ }}</template>
        <!-- <template v-slot:index>第{{ index + 1 }}页</template> -->
      </van-image-preview>
      <van-image-preview v-model="showMainImg" :images="[selectMainImg]" @change="onMainChange">
        <template v-slot:index>{{ }}</template>
        <!-- <template v-slot:index>第{{ index + 1 }}页</template> -->
      </van-image-preview>
    </div>
</template>

<script>
import Buy from '../../components/footer/Buy.vue'
import { queryGoodsById, wxSdk } from '@/api/api'
// import { queryGoodsById, createCart, queryCartGoodsTotalAmount, wxSdk } from '@/api/api'
import Tabs from '../../components/tabs/index.vue'
const seo = require('../../../config/index')
import { getopenIdByCode, isWeiXin, getBaseInfos } from '@/utils/index';
import wx from "weixin-js-sdk";
import goPageConfirm from '../../components/dialog/GoPageConfirm.vue'
import { Toast, ImagePreview } from 'vant'
import list from '../../assets/json/PCSList.json'

export default {
  name: 'Description',
  components: {
    Buy,
    Tabs,
    [ImagePreview.Component.name]: ImagePreview.Component,
    goPageConfirm
  },
  created(){
    // this.initOpenId()
  },
  mounted(){
    this.$bus.$on('changeTaaab', this.changeTab)
    window.addEventListener('scroll',this.handleScroll);
    // if(this.$store.state.userAgent !== 'Mobile'){
    //     document.getElementById("shop-desc").style.cssText= 'margin-top: 58px';
    // }
    this.init()
  },
  deactivated(){
    window.removeEventListener('scroll',this.handleScroll);
    document.querySelector('body').style.overflow = '' // 恢复滚动
  },
  destroyed(){
    document.querySelector('body').style.overflow = '' // 恢复滚动
  },
  data:()=>{
    return {
      swipeImgUrl:[require('../../assets/images/default-shop-desc-swiper.png')],
      descImgUrl:[
        require('../../assets/images/default-shop-desc-swiper.png'),
      ],
      mainListImgUrl:'',
      options:[],
      logo: seo.config.logo,
      goods:{},
      showGoPageConfirm:false,
      orderInfo:{
        title:'', // 标题
        amount: 1, // 数量
        type: '', // 款式
        originalCost: 0, // 单件的原价
        discount: 0, // 折扣
        totalPrice: 0, // 总价
        expressCharge: 0, // 运费
        discountPrice: 0, // 享受的优惠价格
        finalPayPrice: 0, // 最终支付价格
        imgUrl: '', // 商品图片
      },
      showPopup: false,
      activeName: ['1','2'],
      showtabs: false,
      opacityStyle:{
        opacity:0
      },
      shopName: seo.config.shopName,
      appName: seo.config.appName,
      isShortage: false,
      buttonType: '',
      isLogin: localStorage.getItem('token') ? true : false,
      servicePhone: seo.config.servicePhone,
      goodsDescHtml: null,
      selectSizeImg: '', // 选中的款式图片
      selectDescImg: '', // 选中的详情图片
      selectMainImg: '', // 选中的主图图片
      showSizeImg:false,
      showDescImg: false,
      showMainImg: false,
      index:0,
      unitList:[]
    }
  },
  methods:{
    async init(){
      await this.getData()
      await this.wxShare()
    },
    async getData(){
      let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))[0] : ''
      queryGoodsById({ gid: this.$route.query.gid, uid: String(userInfo.uid), partner_level: userInfo.partner_level }).then((res)=>{
        if(Object.keys(res.data.data).length > 0){
          this.swipeImgUrl = res.data.data.mini_main_img_url.split(',')
          this.descImgUrl = res.data.data.mini_desc_img_url.split(',')
          this.mainListImgUrl = res.data.data.mini_main_list_img_url
          this.goods.title = res.data.data.title
          this.goods.originalCost = res.data.data.price
          this.goods.minPrice = res.data.data.minPrice
          this.goods.maxPrice = res.data.data.maxPrice
          this.goods.desc = res.data.data.desc
          this.goodsDescHtml = res.data.data.desc.replace(/\n/g, '<br><br>')
          this.goods.sizeDesc = res.data.data.sizeDesc
          this.isShortage = res.data.data.onSaleTotal === 0 ? true : false
          this.options.length = 0
          if(res.data.data.options.length !== 0){
              this.options = res.data.data.options
              this.selectOption(Number(this.$route.query.gid))
              this.selectSizeImg = res.data.data.options[0].sizeImgUrl ? res.data.data.options[0].sizeImgUrl : require('../../assets/images/no-image.png')
              // 购物车跳转过来
              if(sessionStorage.getItem('goodDescInfo')){
                let goodDescInfo = JSON.parse(sessionStorage.getItem('goodDescInfo'))
                sessionStorage.removeItem('goodDescInfo')
                this.orderInfo.amount = goodDescInfo.amount
                this.options = this.options.map(option => ({ ...option, isSelected: false }));
                let index = this.options.findIndex(option => option.text === goodDescInfo.type);
                if (index !== -1) {
                  this.options[index].isSelected = true;
                }
              }
          } else {
              let temp = {}
              let str = '默认'
              temp.id = '1'
              temp.text = str
              temp.price = res.data.data.price
              temp.isSelected = true
              this.options.push(temp)
          }
          if(this.$route.query.buynow === '1'){
            this.showPopup = true
            this.buttonType = 'addCart'
          }
          // seo
          document.title = res.data.data.title + '-' + seo.config.appName
          let keywords = '衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
          let description = '在这里选购全网最精致,最实用的灯具产品,入住新家不能没有他,包括但不限于衣柜灯,酒柜灯,橱柜灯,筒灯,小夜灯,壁灯,露营灯,无主灯,感应灯,射灯'
          document.querySelector('meta[name="keywords"]').setAttribute('content', keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', description)
        } else {
          this.showGoPageConfirm = true
          document.querySelector('body').style.overflow = 'hidden' // 阻止弹窗背景滚动
        }
      })
    },
    makePhoneCalls(){
      window.location.href = 'tel:' + this.servicePhone;
    },
    unitClick(id){
      const unitItem = this.unitList.find(item => item.id === id);
      const isSelected = unitItem ? unitItem.isSelected : undefined;
      if(!isSelected){
        // 点击整件、整盒
        this.unitList = this.unitList.map(item => {
          if(item.id === id){
            this.orderInfo.amount = item.amount
          }
          return item.id === id ? { ...item, isSelected: true } : { ...item, isSelected: false }
        });
      } else {
        // 恢复初始
        this.unitList = this.unitList.map(item => {
          return { ...item, isSelected: false }
        });
        this.orderInfo.amount = 1
      }
    },
    createOrder(type){
      if(!this.isShortage){
        this.buttonType = type
        this.showPopup = !this.showPopup
      }
    },
    closeImg(){
      this.showSizeImg = false
    },
    selectOption(id){
      let tempArr = []
      let optTemp = this.options.filter(opt=>{
        return opt.id === id
      })
      let tempText = optTemp[0].text
      let tempType = tempText.split('|')[0].trim() // 如：BB512LW
      let PCSItem = list.PCSList.filter(item=> item.type ===  tempType)
      this.unitList.length = 0
      this.orderInfo.amount = 1
      // 加载整件整盒
      if(PCSItem.length > 0){
        if(PCSItem[0].jianToge){
          this.unitList.push({
            id:'jianToge',
            label:'一件',
            amount: PCSItem[0].jianToge,
            show: true,
            isSelected: false
          })
        }
        if(PCSItem[0].heToge){
          this.unitList.push({
            id:'jianTohe',
            label:'一盒',
            amount: PCSItem[0].heToge,
            show: true,
            isSelected: false
          })
        }
      }
      if(optTemp && optTemp[0].amount > 0){
        this.options.forEach((opt)=>{
          let temp = {}
          temp.id = opt.id
          temp.text = opt.text
          temp.amount = opt.amount
          temp.price = opt.price
          temp.sizeImgUrl = opt.sizeImgUrl && opt.sizeImgUrl.length > 0 ? opt.sizeImgUrl : require('../../assets/images/no-image.png')
          if(id === opt.id){
            temp.isSelected = true
            this.goods.selectedGid = id
            this.orderInfo.type = opt.text
            this.orderInfo.originalCost = opt.price
            this.selectSizeImg = opt.sizeImgUrl && opt.sizeImgUrl.length > 0 ? opt.sizeImgUrl : require('../../assets/images/no-image.png')
          } else {
            temp.isSelected = false
          }
          tempArr.push(temp)
        })
        this.options = tempArr
      }
    },
    changeAmount(val){
      // 检查是否数量为整件、整盒
      const hasAmount = this.unitList.some(item => item.amount === val);
      this.orderInfo.amount = Number(val)
      // 取消整件整盒的选择
      if(!hasAmount){
        this.unitList = this.unitList.map(item => {
          return { ...item, isSelected: false }
        });
      }
    },
    submitOrder(){
      Toast('购买请联系客服')
    },
    // submitOrder(){
    //   // 默认选第一款
    //   let lists = []
    //   this.orderInfo.type = this.orderInfo.type ? this.orderInfo.type : this.options[0].text
    //   this.orderInfo.originalCost = this.orderInfo.originalCost ? this.orderInfo.originalCost : this.options[0].price
    //   if(this.orderInfo.type){
    //     if(this.isLogin){
    //       this.orderInfo.gid = this.goods.selectedGid
    //       this.orderInfo.title = this.goods.title
    //       this.orderInfo.imgUrl = this.mainListImgUrl
    //       this.orderInfo.totalPrice = Math.round(this.orderInfo.amount * 100 * this.orderInfo.originalCost) / 100
    //       this.orderInfo.finalPayPrice = this.orderInfo.totalPrice
    //       this.orderInfo.shop = seo.config.shopName
    //       lists.push(this.orderInfo)
    //       if(this.orderInfo.originalCost !== '暂无报价'){
    //         sessionStorage.setItem('lists', JSON.stringify(lists))
    //         this.$router.push({ path:'/pay', query:{ oid: new Date().getTime(), gid: this.goods.selectedGid } })
    //       } else {
    //         Toast('暂无报价，请联系客服')
    //       }
    //     } else {
    //       sessionStorage.setItem('fromPath', '/shop-desc?gid=33')
    //       this.$router.push({ name:'Login', params:{ text:'选商品' } })
    //     }
    //   } else {
    //     this.$notify({
    //           message: '请选择款式',
    //           duration: 1000,
    //           background: '#ec745b'
    //     })
    //   }
    // },
    // 联系客服
    showServiceDialog(){

    },
    // 放入购物车
    addCart(){
      Toast('采购请联系客服')
    },
    // addCart(){
    //     let tempPrice = this.orderInfo.originalCost ? this.orderInfo.originalCost : this.options[0].price
    //     if(this.isLogin){
    //       let goodInfo = {}
    //       goodInfo.gid = Number(this.goods.selectedGid)
    //       goodInfo.imgUrl = this.mainListImgUrl
    //       goodInfo.title = this.goods.title
    //       goodInfo.type = this.orderInfo.type ? this.orderInfo.type : this.options[0].text
    //       goodInfo.amount = this.orderInfo.amount
    //       goodInfo.price = tempPrice
    //       goodInfo.uid = Number(JSON.parse(localStorage.getItem('userInfo'))[0].uid)
    //       goodInfo.shop = seo.config.shopName
    //       if(tempPrice !== '暂无报价'){
    //         createCart({ goodInfo: goodInfo }).then(()=>{
    //           this.showPopup = !this.showPopup
    //           this.orderInfo.amount = 1 // 默认
    //           this.selectOption(Number(this.goods.selectedGid))
    //           // 重新获取购物车数量
    //           queryCartGoodsTotalAmount({ uid: goodInfo.uid }).then((res)=>{
    //             this.$store.commit('Set_CartAmount_State', res.data.total_amount)
    //             Toast('放入采购车成功~')
    //             if(this.$route.query.buynow === '1'){
    //               this.$router.push('/category')
    //             }
    //           })
    //         })
    //       } else {
    //         Toast('暂无报价，请联系客服')
    //       }
    //     } else {
    //       sessionStorage.setItem('fromPath', '/shop-desc?gid=33')
    //       this.$router.push({ name:'Login', params:{ text:'选商品' } })
    //     }
    // },
    getAddress(){
      
    },
    goBack(){
      let fromPath = sessionStorage.getItem('fromPath')
      if(fromPath && fromPath === '/pay'){
        this.$router.push('/')
        sessionStorage.removeItem('fromPath')
      } else {
        if (window.history.state) { // 有上一页则返回
          this.$router.back()
        } else { // 没有上一页则返回到首页
          this.$router.push('/')
        }
      }
    },
    collapseChange(){

    },
    handleDialogClick(){
      this.$router.push('/')
    },
    handleImgClick(){
      this.showSizeImg = true
    },
    handleMainImgClick(url){
      this.selectMainImg = url
      this.showMainImg = true
    },
    handleDescImgClick(url){
      this.selectDescImg = url
      this.showDescImg = true
    },
    onChange(index) {
      this.index = index;
    },
    onDescChange(index) {
      this.index = index;
    },
    onMainChange(index){
      this.index = index;
    },
    handleScroll(){
        const top = document.documentElement.scrollTop ||  document.body.scrollTop;
        if(top < 100){
            this.showtabs = false;
            let opacity = top / 100;
            opacity = opacity > 1 ? 1 : opacity;    
            this.opacityStyle = { opacity };
        }else{
            this.showtabs = true;
            let opacity = 1
            this.opacityStyle = { opacity };
        }
        let distanceToTop = this.$refs.description ? this.$refs.description.offsetTop : 0
        if(this.$refs.tabs){
          if(top >= distanceToTop - 45){ // 滚动条距离顶部位置 // 详情元素的绝对位置
            this.$refs.tabs.changeTab(1, true)
          } else {
            this.$refs.tabs.changeTab(0, true)
          }
        }
    },
    changeTab(id){
      if(id === 0){
        document.body.scrollTop && document.body.scrollTo({top: 0, behavior: 'smooth'})
        document.documentElement.scrollTop && document.documentElement.scrollTo({top: 0, behavior: 'smooth'})
      } else if(id === 1 && this.$route.path.includes('/shop-desc')){
        let distanceToTop = this.$refs.description.offsetTop - 45 // 绝对位置和tabs的height值
        window.scrollTo({
          top: distanceToTop,
          behavior: "smooth"
        });
      } else if(id === 2){
        let distanceToTop = this.$refs.recommend.offsetTop -45 // 绝对位置和tabs的height值
        window.scrollTo({
          top: distanceToTop,
          behavior: "smooth"
        });
      }
    },
    initOpenId(){
      if(isWeiXin()){
          if(!window.location.href.includes('code=')){
            getBaseInfos('')
          } else {
            getopenIdByCode()
          }
      }
    },
    async wxShare(){
        let url = seo.config.wxConfig.goodsPage.link + this.$route.fullPath
        wxSdk({ url:url }).then(res=>{
          let my = this
          let title = my.goods.title
          let shareImg = seo.config.homeUrl + my.swipeImgUrl[0]
          let shareDesc = my.goods.desc && my.goods.desc.length > 0 ? my.goods.desc : seo.config.wxConfig.goodsPage.desc
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: seo.config.wxConfig.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,// 必填，签名
            jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
            wx.checkJsApi({
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'], // 必填，需要使用的JS接口列表
                success: function(res) {
                // “分享给朋友”及“分享到QQ”
                if (res.checkResult.updateAppMessageShareData || res.checkResult.onMenuShareAppMessage) {
                    wx.updateAppMessageShareData({ 
                      title: title, // 分享标题
                      desc: shareDesc, // 分享描述
                      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                      imgUrl: shareImg, // 分享图标
                      success: function () {
                          // 设置成功
                      }
                    })
                }
                // “分享到朋友圈”及“分享到 QQ 空间”
                if(res.checkResult.updateTimelineShareData || res.checkResult.onMenuShareTimeline){
                    wx.updateTimelineShareData({ 
                      title: title, // 分享标题
                      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
                      imgUrl: shareImg, // 分享图标
                      success: function () {
                          // 设置成功
                      }
                    })
                }
            }})
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.shop-desc-box {
  min-height: 100vh;
  padding-bottom: calc(85px + constant(safe-area-inset-bottom));
  padding-bottom: calc(85px + env(safe-area-inset-bottom));
  position: relative;
}
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
    background-color: #f3f3f3;
}
.title-box {
  background: #fff;
  border-radius: 5px;
  margin: 5px;
  text-align: left;
  padding: 15px 15px 20px;
  font-size: 20px;
  min-height: 60px;
  .price {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 5px;
    min-height: 27px;
    span {
      font-size: 14px;
    }
  }
  .text {
    min-height: 55px;
    display: flex;
    align-items: center;
  }
}
.shop-card {
  display: flex;
  align-items: center;
  background: #fff;
  margin: 10px 5px;
  padding: 15px 15px;
  border-radius: 5px;
  img {
    border-radius: 5px;
  }
  .text {
    margin: 0 10px 0 15px;
    text-align: left;
    font-size: 18px;
    .span {
      font-size: 14px;
      background: #eee;
      color: rgba(0,0,0,0.6);
      margin: 5px 6px 0px 0px;
      padding: 2px 10px;
      border-radius: 2px;
    }
  }
}
.tabs {
  display: flex;
  background: #fff;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  padding: 0 25%;
  border-radius: 5px;
  margin: 0 5px;
  .tab {
    font-size: 16px;
  }
}
.description {
  margin: 0 5px;
  img {
    margin: -2px 0;
  }
}
.collapse {
  margin: 0 5px;
  .size-desc {
    text-align: left;
    .row {
      display: flex;
      font-size: 14px;
      color: #424242;
      margin: 15px 0;
      .label {
        width: 100px;
      }
      .text {
        flex: 1;
      }
    }
    .row-middle {
      display: flex;
      margin: 10px 0;
      .label {
        width: 100px;
      }
      .text {
        flex: 1;
      }
    }
  }
  .goods-desc {
    text-align: left;
    padding: 10px 0 20px;
  }
  .buy-reminder {
    text-align: left;
  }
}
.title-text {
  position: fixed;
  z-index: 9999;
  left: 0px;
  background: #fff;
  border-radius: 25px;
  text-align: left;
  right: 0;
  max-width: 750px;
  margin: 0 auto;
  .text {
    padding: 25px 0 10px 20px;
  }
  .info {
    display: flex;
    align-items: center;
    .img {
      background: #f3f3f3;
      width: 75px;
      height: 75px;
      margin: 5px 0 10px 30px;
      // display: flex;
      img {
        border-radius: 0px;
      }
    }
    .price {
      margin: 0 10px;
      .icon {
        font-size: 18px;
        margin: 0 1px;
      }
      .number {
        font-size: 24px;
      }
    }
  }
}
.order-details {
  text-align: left;
  .type {
    padding: 150px 25px 0;
    .option {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 10px 0;
      cursor: pointer;
      .label {
        display: flex;
        align-items: center;
        padding: 7px 15px;
        border-radius: 5px;
        margin: 0 5px;
        word-break: break-all;
        background: #f3f3f3;
        border: 1px rgba(0,0,0,0.03) solid;
        .img {
          display: flex;
          align-items: center;
          background: #f3f3f3;
          width: 30px;
          height: 30px;
        }
        .text {
          padding: 0 0 0 10px;
        }
      }
      .mark {
        font-size: 12px;
        color: #fc5f10;
      }
    }
    .option-selected {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 10px 0;
      cursor: pointer;
      .label {
        display: flex;
        align-items: center;
        padding: 7px 15px;
        border-radius: 5px;
        margin: 0 5px;
        word-break: break-all;
        background: #FFFAAA;
        border: 1px rgba(0,0,0,0.03) solid;
        .img {
          display: flex;
          align-items: center;
        }
        .text {
          padding: 0 0 0 10px;
        }
      }
    }
  }
  .unit {
    padding: 15px 25px 0px;
    .row {
      margin-bottom: 10px;
      .text {

      }
      .label-row {
        padding: 15px 0 0;
        display: flex;
        justify-content: flex-start;
        .label {
          background-color: #f2f3f5;
          border: 1px rgba(0, 0, 0, 0.03) solid;
          padding: 4px 15px;
          border-radius: 5px;
          margin-right: 15px;
        }
        .label-active {
          background-color: #FFFAAA;
          border: 1px rgba(0, 0, 0, 0.03) solid;
          padding: 4px 15px;
          border-radius: 5px;
          margin-right: 15px;
        }
      }
    }
  }
  .amount {
    padding: 10px 25px 65px;
    padding-bottom: calc(65px + constant(safe-area-inset-bottom));
    padding-bottom: calc(65px + env(safe-area-inset-bottom));
    .title {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
.button-row {
  position: fixed;
  bottom: 0px;
  right: 0;
  z-index: 9998;
  display: flex;
  justify-content: center;
  padding: 10px;
  padding-bottom: calc(10px + constant(safe-area-inset-bottom));
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-sizing: border-box;
  max-width: 750px;
  margin: 0 auto;
  left: 0;
  .button-buy {
      width: 80%;
      height: 38px;
      display: flex;
      margin: 0 10px;
      line-height: 25px;
      border-radius: 25px;
      align-items: center;
      font-size: 14px;
      color: #fff;
      justify-content: center;
      background: #29323c;
      border: 1px solid #29323c;
      // background: #fc5f10;
      // border: 1px solid #fc5f10;
      cursor: pointer;
      .icon {
        font-size: 16px;
        margin-right: 1px;
        display: flex;
        align-items: center;
      }
      .span {
        font-size: 20px;
        font-weight: 100;
      }
  }
  .button-buy-cart {
    width: 80%;
    height: 38px;
    display: flex;
    // margin: 0 10px;
    line-height: 25px;
    border-radius: 25px;
    align-items: center;
    font-size: 14px;
    color: #fff;
    justify-content: center;
    background: #596470;
    border: 1px solid #596470;
    // background: #fbbc05;
    // border: 1px solid #fbbc05;
  }
}
.sizeParams {
  background: #fff;
  text-align: left;
  margin: 0 5px;
  font-size: 14px;
}
.priceDesc {
  background: #fff;
  text-align: left;
  margin: 0 5px;
  font-size: 14px;
}
.back-img {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1101;
  background: rgba(250, 250, 250, 0.5);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  padding: 6px 4px;
  box-sizing: border-box;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
::v-deep .van-cell__title, .van-cell__value {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
}
::v-deep .van-popup--bottom {
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0 auto;
}
::v-deep .van-image-preview__overlay {
    background-color: rgba(0,0,0,1);
}
::v-deep .van-image-preview__swipe {
    height: 100%;
    background-color: rgba(0,0,0,1);
}
::v-deep .van-image-preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999 !important;
}
</style>